module.exports = __webpack_public_path__ + "img/Wp_2019.a739e923.png";